import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import SiteFooter from '../components/SiteFooter';

export default function PrivacyPolicyPage() {
  return (
    <Box sx={{ width: '100%' }}>
      <Container maxWidth="md" sx={{ mx: 'auto', pt: 6, pb: 4, px: 2 }}>
        <Typography variant="h4" gutterBottom>
          Privacy Policy
        </Typography>
        <Typography variant="body1" paragraph>
          This policy explains how Medskool.org collects, uses, and protects your personal
          information. We collect only the data needed to operate the service, such as your
          account details and content you submit. Cookies are used solely for authentication
          and to remember your preferences.
        </Typography>
        <Typography variant="body1" paragraph>
          Course reviews are anonymous to other users. Only you can see and edit your own
          reviews. In the community forums you may choose a separate username and avatar.
          Each application can have its own identity so you remain in control of what you
          share.
        </Typography>
        <Typography variant="body1" paragraph>
          We never sell your data. Information may be shared with service providers who help
          operate the website, but they may only use it on our behalf. We retain content and
          account data as long as your account remains active or as required for legal
          compliance. You may contact us to request deletion of your account.
        </Typography>
        <Typography variant="body1" paragraph>
          We may update this policy from time to time. Significant changes will be announced
          on the site. Continued use of Medskool.org means you accept the updated policy.
        </Typography>
      </Container>
      <SiteFooter />
    </Box>
  );
}
